export default () => ({
  pageSize: 10,
  retrospectiveDay: 14,
  searchTerm: '',
  sortDir: 'desc',
  orderBy: 'startDate',
  workOrderQueue: [],
  techQueue: [],
  toolQueue: [],
  workOrderQueueFiltered: [],
  techQueueFiltered: [],
  toolQueueFiltered: [],
  dispatchLog: [],
  queue: [],
  breakdownSummary: null
})



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/state.js